<template>
  <CarouselSlide class="ukasko-slide">
    <FeaturesList
      class="ukasko-slide__list"
      title="Стало з UConnect"
      list-type="fancy"
      :items="getUkaskoItems"
      :image-components="getUkaskoItemsImageComponents"
    />
  </CarouselSlide>
</template>

<script>
import FeaturesList from '../../features-list';
import { textBlock } from '@/entities/text-block';
import {
  BellImage,
  BustsInSilhouetteImage,
  ChartIncreasingImage,
  LaptopImage,
  MoneyBagImage,
  StarStruckImage,
} from '@/shared/ui/promo';
import { CarouselSlide } from '@/shared/ui/slider';

export default {
  mixins: [ textBlock ],
  components: { FeaturesList, CarouselSlide },
  computed: {
    getUkaskoItemsImageComponents() {
      return {
        LaptopImage,
        BellImage,
        ChartIncreasingImage,
        StarStruckImage,
        MoneyBagImage,
        BustsInSilhouetteImage
      };
    },
    getUkaskoItems() {
      return [
        {
          icon: 'LaptopImage',
          text: this.getListBlock('promo', 'connect-features-after')[0],
        },
        {
          icon: 'BellImage',
          text: this.getListBlock('promo', 'connect-features-after')[1],
        },
        {
          icon: 'ChartIncreasingImage',
          text: this.getListBlock('promo', 'connect-features-after')[2],
        },
        {
          icon: 'StarStruckImage',
          text: this.getListBlock('promo', 'connect-features-after')[3],
        },
        {
          icon: 'MoneyBagImage',
          text: this.getListBlock('promo', 'connect-features-after')[4],
        },
        {
          icon: 'BustsInSilhouetteImage',
          text: this.getListBlock('promo', 'connect-features-after')[5],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.ukasko-slide {
  padding: 0 16px 70px;
}
</style>
